var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnTrashbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3594 6.2373H21.3594V8.2373H19.3594V21.2373C19.3594 21.7896 18.9117 22.2373 18.3594 22.2373H4.35938C3.8071 22.2373 3.35938 21.7896 3.35938 21.2373V8.2373H1.35938V6.2373H6.35938V3.2373C6.35938 2.68502 6.8071 2.2373 7.35938 2.2373H15.3594C15.9117 2.2373 16.3594 2.68502 16.3594 3.2373V6.2373ZM17.3594 8.2373H5.35938V20.2373H17.3594V8.2373ZM8.35938 11.2373H10.3594V17.2373H8.35938V11.2373ZM12.3594 11.2373H14.3594V17.2373H12.3594V11.2373ZM8.35938 4.2373V6.2373H14.3594V4.2373H8.35938Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTrashbin);
export default __webpack_public_path__ + "static/media/btn_trashbin.343358c62271ddb6d8f40b7be85868bc.svg";
export { ForwardRef as ReactComponent };